import * as React from 'react';
import { useLocation } from '@grandvisionhq/frk-routing';
import { compose } from '@grandvisionhq/utils';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';
import { CmsContentBreadcrumbs } from './ContentBreadcrumbs/ContentBreadcrumbs.js';

const CmsBreadcrumbs = ()=>{
    const { pathname  } = useLocation();
    return /*#__PURE__*/ React.createElement(CmsContentBreadcrumbs, {
        url: pathname
    });
};
var Breadcrumbs = compose(withHidableContent)(CmsBreadcrumbs);

export { CmsBreadcrumbs, Breadcrumbs as default };
//# sourceMappingURL=Breadcrumbs.js.map
